import React from 'react';
import Styles from "../../../scss/orderHistory.module.scss";
import IColumn from "../../../yoello-lib/modules/components/lists/interfaces/IColumn";
import OrderTypeIcon from '../OrderList/OrderTypeIcon';
import { toLocalDate, toLocalTime } from '../../../yoello-lib/modules/utils/TimeConversion';
import { stateStylings } from '../constants';
import { useTranslation } from 'react-i18next';

export const columns: IColumn<any>[] =
    [
        {
            label: "orderHistory.table.orderId", key: "hash_id",
            componentTransform: (orderId) => {
                return <span key={orderId} className={Styles.orderHashId} data-component-name={orderId}>
                    {orderId}
                </span>
            }
        },
        {
            label: "orderHistory.table.orderType", key: "order_type",
            componentTransform: (orderType, key) => {
                return <span key={`${key}-order-type`} className={Styles.orderType}>
                    <OrderTypeIcon orderType={orderType} fill={"transparent"} />
                </span>
            },
        },
        {
            label: "orderHistory.table.orderTime", key: "created_on",
            componentTransform: (time, key) => {
                return <span key={`${key}-time`}>{toLocalTime(time)} </span>
            }
        },
        {
            label: "orderHistory.table.orderDate", key: "created_on",
            componentTransform: (date, key) => {
                return <span key={`${key}-date`}>{toLocalDate(date)}</span>
            }
        },
        {
            label: "orderHistory.table.totalPrice", key: "order_total",
            componentTransform: (total, key) => {
                return <span key={`${key}-total`} className={Styles.orderTotalPrice}>{total}</span>
            }
        },
        {

            label: "orderHistory.table.status", key: "order_status", componentTransform: (status, key) => {
                return <span key={`${key}-status`} className={Styles.orderStatus} data-component-name={status}>
                    <StatusText status={status} />
                </span>
            }
        }
    ]

export function StatusText(props: any) {
    const { t } = useTranslation();
    return <span style={{ ...(stateStylings["DEFAULT"]), fontSize: "inherit" }}>
        {t(`orderTypes.${props.status.toLowerCase()}`)}
    </span>
}